import { useState } from 'react'
import { router } from '@inertiajs/react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Building2, ShieldCheck } from 'lucide-react'

interface Props {
  invite: { token: string; organization_name: string; owner_name: string; phone_hint: string; expires_at: string }
  step: 'request_otp' | 'verify_otp'
  errors?: Record<string, string>
}

export default function Accept({ invite, step, errors = {} }: Props) {
  const [code, setCode] = useState('')
  const [processing, setProcessing] = useState(false)
  const path = `/owner-invite/${invite.token}`

  const submit = (event: React.FormEvent) => {
    event.preventDefault()
    setProcessing(true)
    router.post(`${path}/${step === 'request_otp' ? 'request_otp' : 'verify_otp'}`, step === 'verify_otp' ? { code } : {}, {
      onFinish: () => setProcessing(false),
    })
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
            {step === 'request_otp' ? <Building2 className="h-6 w-6" /> : <ShieldCheck className="h-6 w-6" />}
          </div>
          <CardTitle>{step === 'request_otp' ? `Te damos la bienvenida a ${invite.organization_name}` : 'Confirma tu WhatsApp'}</CardTitle>
          <CardDescription>
            {step === 'request_otp'
              ? `${invite.owner_name}, verifica tu número para activar el acceso como propietaria.`
              : `Escribe el código enviado al número terminado en ${invite.phone_hint.slice(-4)}.`}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            {step === 'verify_otp' && (
              <div className="space-y-2">
                <Label htmlFor="code">Código de 6 dígitos</Label>
                <Input id="code" value={code} onChange={(e) => setCode(e.target.value)} inputMode="numeric" autoComplete="one-time-code" required autoFocus />
                {errors.code && <p className="text-sm text-destructive">{errors.code}</p>}
              </div>
            )}
            {errors.phone && <p className="text-sm text-destructive">{errors.phone}</p>}
            <Button type="submit" className="w-full" disabled={processing}>
              {processing ? 'Procesando...' : step === 'request_otp' ? 'Enviar código por WhatsApp' : 'Activar mi organización'}
            </Button>
          </form>
          <p className="mt-5 text-center text-xs text-muted-foreground">Este enlace vence el {new Date(invite.expires_at).toLocaleString('es-MX')}.</p>
        </CardContent>
      </Card>
    </div>
  )
}
